import React, { useState, useEffect } from 'react'
import MaterialTable from 'material-table'
import {
  TextField,
  Button,
  Select,
  MenuItem,
  Grid,
  FormControlLabel,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Snackbar,
  IconButton,
  InputLabel,
} from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import DeleteIcon from '@material-ui/icons/Delete'
import AttachFileIcon from '@material-ui/icons/AttachFile'
import DateFnsUtils from '@date-io/date-fns'
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers'
import './SostenibilidadAguaContainer.css'
import {
  getEnsambladoras,
  getAgua,
  postAgua,
  getTipos,
  getPermisosByUser,
  deleteAgua,
} from '@auteco/services/sostenibilidadService'

const SostenibilidadAguaContainer = () => {
  const [data, setData] = useState([])
  const [open, setOpen] = useState(false)
  const [touched, setTouched] = useState({})
  const [notification, setNotification] = useState({ open: false, message: '', severity: 'success' })
  const [tipo, setTipo] = useState('')
  const [fechaInicial, setFechaInicial] = useState(null)
  const [fechaFinal, setFechaFinal] = useState(null)
  const [m3, setM3] = useState('')
  const [costoM3, setCostoM3] = useState('')
  const [empresa, setEmpresa] = useState('')
  const [sede, setSede] = useState('')
  const [contrato, setContrato] = useState('')
  const [autoconsumo, setAutoconsumo] = useState(false)
  const [tiposList, setTiposList] = useState([])
  const [contratosList, setContratosList] = useState([])
  const [empresasList, setEmpresasList] = useState([])
  const [sedesList, setSedesList] = useState([])
  const [permisos, setPermisos] = useState(0)
  const [archivo, setArchivo] = useState(null)

  const handleFieldTouch = (field) => {
    setTouched(prev => ({ ...prev, [field]: true }))
  }

  const handleGetAgua = async () => {
    try {
      const response = await getAgua()
      if (response && response.agua) {
        setData(response.agua)
      }
    } catch (err) {
      console.error('Error al cargar agua:', err)
    }
  }

  const resetForm = () => {
    setTipo('')
    setFechaInicial(null)
    setFechaFinal(null)
    setM3('')
    setCostoM3('')
    setEmpresa('')
    setSede('')
    setContrato('')
    setAutoconsumo(false)
    setArchivo(null)
    setTouched({})
  }

  const handleClose = () => {
    setOpen(false)
    resetForm()
  }

  function formatearFecha(date) {
    if (!date) return null
    const fechaFormat = new Date(date)
    const año = fechaFormat.getFullYear()
    const mes = (fechaFormat.getMonth() + 1).toString().padStart(2, '0')
    const dia = fechaFormat.getDate().toString().padStart(2, '0')
    return `${año}-${mes}-${dia}`
  }

  const columns = [
    {
      title: 'Empresa',
      field: 'ensambladora_id',
      render: (rowData) => {
        const empresaFind = empresasList.find(
          (emp) => emp.id === rowData.ensambladora_id,
        )
        return empresaFind ? empresaFind.nombre : 'Desconocida'
      },
    },
    {
      title: 'Sede',
      field: 'ensambladora_id',
      render: (rowData) => {
        const ensambl = empresasList.find(
          (emp) => emp.id === rowData.ensambladora_id,
        )
        if(ensambl && ensambl.sedes && ensambl.sedes.length > 0){
          const sedeT = ensambl.sedes.find((sedeTT) =>parseInt(sedeTT.id, 10) === parseInt(rowData.sede_id, 10))
          return sedeT ? sedeT.nombre  : 'Desconocida'
        }
        return 'Desconocida s'
      },
    },
    { title: 'Fecha Inicial', field: 'fecha_inicial', type: 'date' },
    { title: 'Fecha Final', field: 'fecha_final', type: 'date' },
    { title: 'm3', field: 'm3' },
    { title: 'costo M3', field: 'costo_m3', type: 'numeric' },
    {
      title: 'Contrato',
      field: 'contrato_id',
      render: rowData => {
        const contratoFind = contratosList.find(c => c.id === rowData.contrato_id);
        return contratoFind ? contratoFind.nombre : 'Desconocido';
      }
    },
    {
      title: 'Archivo',
      field: 'archivo_url',
      render: (rowData) => (
        <IconButton onClick={() => window.open(rowData.archivo_url)}>
          <AttachFileIcon />
        </IconButton>
      ),
    },
    {
      title: 'Acciones',
      field: 'acciones',
      render: (rowData) => (
        <IconButton onClick={() => handleDeleteAgua(rowData.id)}>
          <DeleteIcon />
        </IconButton>
      ),
    },
  ]

  const handleCloseNotification = () => {
    setNotification({ ...notification, open: false })
  }

  const handleAdd = async () => {
    try {
      const reader = new FileReader()
      reader.onload = async () => {
        const base64Archivo = reader.result
        const body = {
          tipoId: parseInt(tipo, 10),
          ensambladoraId: parseInt(empresa, 10),
          sedeId: parseInt(sede, 10),
          fechaInicial: formatearFecha(fechaInicial),
          fechaFinal: formatearFecha(fechaFinal),
          m3: parseFloat(m3),
          costoM3: parseFloat(costoM3),
          contratoId: parseInt(contrato, 10),
          autoconsumo,
          archivo: base64Archivo,
        }
        const response = await postAgua(body)

        if (response && response.data.id) {
          setNotification({
            open: true,
            message: 'Registro guardado correctamente',
            severity: 'success'
          })
          handleClose()
          await handleGetAgua()
        } else {
          setNotification({
            open: true,
            message: 'Error al guardar',
            severity: 'error'
          })
        }
      }

      if (archivo) {
        reader.readAsDataURL(archivo)
      } else {
        const body = {
          tipoId: parseInt(tipo, 10),
          ensambladoraId: parseInt(empresa, 10),
          sedeId: parseInt(sede, 10),
          fechaInicial: formatearFecha(fechaInicial),
          fechaFinal: formatearFecha(fechaFinal),
          m3: parseFloat(m3),
          costoM3: parseFloat(costoM3),
          contratoId: parseInt(contrato, 10),
          autoconsumo,
        }
        const response = await postAgua(body)

        if (response && response.data.id) {
          setNotification({
            open: true,
            message: 'Registro guardado correctamente',
            severity: 'success'
          })
          handleClose()
          await handleGetAgua()
        } else {
          setNotification({
            open: true,
            message: 'Error al guardar',
            severity: 'error'
          })
        }
      }
    } catch (err) {
      console.error('Error al guardar:', err)
      setNotification({
        open: true,
        message: 'Error al guardar',
        severity: 'error'
      })
    }
  }

  const handleGetEmpresas = async () => {
    try {
      const response = await getEnsambladoras()
      if (response && response.ensambladoras) {
        setEmpresasList(response.ensambladoras)
      }
    } catch (err) {
      console.error('Error al cargar empresas:', err)
    }
  }

  const handleGetTipos = async () => {
    try {
      const response = await getTipos()
      if (response && response.tipos) {
        setTiposList(response.tipos.filter((item) => item.tipo_id === '5'))
        setContratosList(response.tipos.filter((item) => item.tipo_id === '6'))
      }
    } catch (err) {
      console.error('Error al cargar tipos:', err)
    }
  }

  const handleGetPermisosByUser = async () => {
    try {
      const response = await getPermisosByUser()
      if (response && response.permisos) {
        const aguaPermiso = response.permisos.find(permiso => permiso.nombre === 'Agua');
        if (aguaPermiso) {
          setPermisos(parseInt(aguaPermiso.alcance, 10))
        }
      }
    } catch (err) {
      console.error('Error al cargar permisos:', err)
    }
  }

  const handleEmpresaChange = (e) => {
    const selectedEmpresaId = e.target.value
    setEmpresa(selectedEmpresaId)
    
    const selectedEmpresa = empresasList.find(emp => emp.id === selectedEmpresaId)
    if (selectedEmpresa && selectedEmpresa.sedes) {
      setSedesList(selectedEmpresa.sedes)
    } else {
      setSedesList([])
    }
    
    setSede('')
  }

  const handleDeleteAgua = async (id) => {
    try {
      const response = await deleteAgua(id)
      console.log(response)
      if (response.data && response.data.success) {
        setNotification({
          open: true,
          message: 'Registro eliminado correctamente',
          severity: 'success'
        })
        await handleGetAgua()
      } else {
        setNotification({
          open: true,
          message: 'Error al eliminar el registro',
          severity: 'error'
        })
      }
    } catch (err) {
      console.error('Error al eliminar:', err)
      setNotification({
        open: true,
        message: 'Error al eliminar el registro',
        severity: 'error'
      })
    }
  }

  useEffect(() => {
    handleGetAgua()
    handleGetTipos()
    handleGetEmpresas()
    handleGetPermisosByUser()
  }, [])

  if (permisos === 0) {
    return <div><p>No tienes permisos para ver esta sección</p></div>
  }

  return (
    <div>
      {permisos > 0 && (
        <MaterialTable
          title="Registros de Agua"
          columns={columns}
          data={data}
          options={{
            headerStyle: {
              backgroundColor: '#f1f1f1',
              color: 'black',
              fontWeight: 'bold',
            },
          }}
        />
      )}
      {permisos > 1 && (
        <Button
          variant="contained"
          color="primary"
          onClick={() => setOpen(true)}
          style={{ margin: '10px' }}
        >
          Agregar Registro
        </Button>
      )}

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        maxWidth="md"
        fullWidth
      >
        <DialogTitle id="form-dialog-title">Registro de Agua</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Select
                value={tipo}
                onChange={(e) => setTipo(e.target.value)}
                onBlur={() => handleFieldTouch('tipo')}
                displayEmpty
                fullWidth
                required
                error={touched.tipo && !tipo}
              >
                <MenuItem value="" disabled>
                  Tipo de agua *
                </MenuItem>
                {tiposList.map((agua) => (
                  <MenuItem key={agua.id} value={agua.id}>
                    {agua.nombre}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item xs={6}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  margin="normal"
                  id="fechaInicial"
                  label="Fecha Inicial *"
                  format="dd/MM/yyyy"
                  value={fechaInicial}
                  onChange={setFechaInicial}
                  onBlur={() => handleFieldTouch('fechaInicial')}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                  fullWidth
                  required
                  error={touched.fechaInicial && !fechaInicial}
                  helperText={touched.fechaInicial && !fechaInicial ? 'Campo requerido' : ' '}
                />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={6}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  margin="normal"
                  id="fechaFinal"
                  label="Fecha Final *"
                  format="dd/MM/yyyy"
                  value={fechaFinal}
                  onChange={setFechaFinal}
                  onBlur={() => handleFieldTouch('fechaFinal')}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                  fullWidth
                  required
                  error={touched.fechaFinal && !fechaFinal}
                  helperText={touched.fechaFinal && !fechaFinal ? 'Campo requerido' : ' '}
                />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="M3 *"
                type="number"
                value={m3}
                onChange={(e) => setM3(e.target.value)}
                onBlur={() => handleFieldTouch('m3')}
                fullWidth
                required
                error={touched.m3 && !m3}
                helperText={touched.m3 && !m3 ? 'Campo requerido' : ' '}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Costo M3 *"
                type="number"
                value={costoM3}
                onChange={(e) => setCostoM3(e.target.value)}
                onBlur={() => handleFieldTouch('costoM3')}
                fullWidth
                required
                error={touched.costoM3 && !costoM3}
                helperText={touched.costoM3 && !costoM3 ? 'Campo requerido' : ' '}
              />
            </Grid>
            <Grid item xs={12}>
              <Select
                value={empresa}
                onChange={handleEmpresaChange}
                onBlur={() => handleFieldTouch('empresa')}
                displayEmpty
                fullWidth
                required
                error={touched.empresa && !empresa}
              >
                <MenuItem value="" disabled>
                  Empresa *
                </MenuItem>
                {empresasList.map((empres) => (
                  <MenuItem key={empres.id} value={empres.id}>
                    {empres.nombre}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item xs={12}>
              <Select
                value={sede}
                onChange={(e) => setSede(e.target.value)}
                onBlur={() => handleFieldTouch('sede')}
                displayEmpty
                fullWidth
                required
                disabled={!empresa}
                error={touched.sede && !sede}
              >
                <MenuItem value="" disabled>
                  Sede *
                </MenuItem>
                {sedesList.map((s) => (
                  <MenuItem key={s.id} value={s.id}>
                    {s.nombre}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item xs={12}>
              <Select
                value={contrato}
                onChange={(e) => setContrato(e.target.value)}
                onBlur={() => handleFieldTouch('contrato')}
                displayEmpty
                fullWidth
                required
                error={touched.contrato && !contrato}
              >
                <MenuItem value="" disabled>
                  Contrato *
                </MenuItem>
                {contratosList.map((contratoFind) => (
                  <MenuItem key={contratoFind.id} value={contratoFind.id}>
                    {contratoFind.nombre}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={autoconsumo}
                    onChange={(e) => setAutoconsumo(e.target.checked)}
                    name="autoconsumo"
                    color="primary"
                  />
                }
                label="Autoconsumo"
              />
            </Grid>
            <Grid item xs={12}>
              <InputLabel htmlFor="archivo" error={touched.archivo && !archivo}>Archivo *</InputLabel>
              <input
                type="file"
                id="archivo"
                required
                onChange={(e) => setArchivo(e.target.files[0])}
                onBlur={() => handleFieldTouch('archivo')}
              />
              {touched.archivo && !archivo && (
                <p style={{ color: '#f44336', fontSize: '0.75rem', marginTop: '3px' }}>Campo requerido</p>
              )}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancelar
          </Button>
          <Button
            onClick={handleAdd}
            color="primary"
            disabled={
              !tipo ||
              !fechaInicial ||
              !fechaFinal ||
              !m3 ||
              !costoM3 ||
              !empresa ||
              !sede ||
              !contrato ||
              !archivo
            }
          >
            Guardar
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={notification.open}
        autoHideDuration={6000}
        onClose={handleCloseNotification}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseNotification} severity={notification.severity}>
          {notification.message}
        </Alert>
      </Snackbar>
    </div>
  )
}

export default SostenibilidadAguaContainer